import * as React from "react";
import { useContext } from "react";
import styled from "styled-components";
import Spinner from "components/common/Spinner";
import WidgetContext from "views/components/contexts/WidgetContext";
import QueryEditModeContext from "views/components/contexts/QueryEditModeContext";
import SaveOrCancelButtons from "views/components/widgets/SaveOrCancelButtons";
import WidgetEditApplyAllChangesProvider from "views/components/contexts/WidgetEditApplyAllChangesProvider";
import WidgetQueryControls from "../WidgetQueryControls";
import WidgetOverrideElements from "../WidgetOverrideElements";
import DisableSubmissionStateProvider from "../contexts/DisableSubmissionStateProvider";
const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1;
  overflow: hidden;
`;
const QueryControls = styled.div`
  margin-bottom: 10px;
`;
const Visualization = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
`;
const EditWidgetFrame = ({
  children,
  onCancel,
  onSubmit,
  displaySubmitActions = true,
  showQueryControls = true,
  containerComponent: ContainerComponent = WidgetOverrideElements
}) => {
  const widget = useContext(WidgetContext);
  if (!widget) {
    return /* @__PURE__ */ React.createElement(Spinner, { text: "Loading widget ..." });
  }
  return /* @__PURE__ */ React.createElement(WidgetEditApplyAllChangesProvider, { widget, onSubmit }, /* @__PURE__ */ React.createElement(DisableSubmissionStateProvider, null, /* @__PURE__ */ React.createElement(Container, null, showQueryControls && !widget.returnsAllRecords && /* @__PURE__ */ React.createElement(QueryControls, null, /* @__PURE__ */ React.createElement(QueryEditModeContext.Provider, { value: "widget" }, /* @__PURE__ */ React.createElement(WidgetQueryControls, null))), /* @__PURE__ */ React.createElement(Visualization, { role: "presentation" }, /* @__PURE__ */ React.createElement(ContainerComponent, null, children)), displaySubmitActions && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(SaveOrCancelButtons, { onCancel })))));
};
export default EditWidgetFrame;
